export default __webpack_public_path__ + "bart_oct_31st.f1a01d6c.png";